import React from 'react';
import SamuraiGame from '../SamuraiGame';

const TexasStarSamurai = () => {
    return <SamuraiGame initialDrillIndex={7} />;
};

export default TexasStarSamurai;
